import { AxiosError } from 'axios';
import { ActionType, createAsyncAction } from 'typesafe-actions';
import {
  TokenAccount,
  UserAccount,
  UserPw,
  UserData,
  UserPageData,
  UpdateData,
  UserPwCheck
} from '../models/authModel';

const USERS_LOGIN_REQUEST = 'auth/USERS_LOGIN_REQUEST';
const USERS_LOGIN_SUCCESS = 'auth/USERS_LOGIN_SUCCESS';
const USERS_LOGIN_FAILURE = 'auth/USERS_LOGIN_FAILURE';

const CHECK_AUTHENCATION_REQUEST = 'auth/CHECK_AUTHENCATION_REQUEST';
const CHECK_AUTHENCATION_SUCCESS = 'auth/CHECK_AUTHENCATION_SUCCESS';
const CHECK_AUTHENCATION_FAILURE = 'auth/CHECK_AUTHENCATION_FAILURE';

const USERS_LOGOUT_REQUEST = 'auth/USERS_LOGOUT_REQUEST';
const USERS_LOGOUT_SUCCESS = 'auth/USERS_LOGOUT_SUCCESS';
const USERS_LOGOUT_FAILURE = 'auth/USERS_LOGOUT_FAILURE';

//mypage list
const USERS_USERPAGE_REQUEST = 'auth/USERS_USERPAGE_REQUEST';
const USERS_USERPAGE_SUCCESS = 'auth/USERS_USERPAGE_SUCCESS';
const USERS_USERPAGE_FAILURE = 'auth/USERS_USERPAGE_FAILURE';

//# mypage update
const USERS_UPDATE_REQUEST = 'auth/USERS_UPDATE_REQUEST';
const USERS_UPDATE_SUCCESS = 'auth/USERS_UPDATE_SUCCESS';
const USERS_UPDATE_FAILURE = 'auth/USERS_UPDATE_FAILURE';

const USERS_PWUPDATE_REQUEST = 'auth/USERS_PWUPDATE_REQUEST';
const USERS_PWUPDATE_SUCCESS = 'auth/USERS_PWUPDATE_SUCCESS';
const USERS_PWUPDATE_FAILURE = 'auth/USERS_PWUPDATE_FAILURE';
//mypage delete
const USERS_DELETE_REQUEST = 'auth/USERS_DELETE_REQUEST';
const USERS_DELETE_SUCCESS = 'auth/USERS_DELETE_SUCCESS';
const USERS_DELETE_FAILURE = 'auth/USERS_DELETE_FAILURE';

//mypage pwcheck
const USERS_PWCheck_REQUEST = 'auth/USERS_PWCheck_REQUEST';
const USERS_PWCheck_SUCCESS = 'auth/USERS_PWCheck_SUCCESS';
const USERS_PWCheck_FAILURE = 'auth/USERS_PWCheck_FAILURE';

export const login = createAsyncAction(
  USERS_LOGIN_REQUEST,
  USERS_LOGIN_SUCCESS,
  USERS_LOGIN_FAILURE
)<UserAccount, UserData, string>();

export const check = createAsyncAction(
  CHECK_AUTHENCATION_REQUEST,
  CHECK_AUTHENCATION_SUCCESS,
  CHECK_AUTHENCATION_FAILURE
)<void, { isLogin: boolean; user?: UserData }, AxiosError>();

export const logout = createAsyncAction(
  USERS_LOGOUT_REQUEST,
  USERS_LOGOUT_SUCCESS,
  USERS_LOGOUT_FAILURE
)<void, void, AxiosError>();

export const refresh = createAsyncAction(
  USERS_LOGOUT_REQUEST,
  USERS_LOGOUT_SUCCESS,
  USERS_LOGOUT_FAILURE
)<TokenAccount, UserData, AxiosError>();

export const userupdateAction = createAsyncAction(
  USERS_UPDATE_REQUEST,
  USERS_UPDATE_SUCCESS,
  USERS_UPDATE_FAILURE
)<UpdateData, UserPageData, AxiosError>();

export const userPageAction = createAsyncAction(
  USERS_USERPAGE_REQUEST,
  USERS_USERPAGE_SUCCESS,
  USERS_USERPAGE_FAILURE
)<string, UserPageData, AxiosError>();

export const userDeleteAction = createAsyncAction(
  USERS_DELETE_REQUEST,
  USERS_DELETE_SUCCESS,
  USERS_DELETE_FAILURE
)<string, void, AxiosError>();

export const pwUpdateAction = createAsyncAction(
  USERS_PWUPDATE_REQUEST,
  USERS_PWUPDATE_SUCCESS,
  USERS_PWUPDATE_FAILURE
)<UserPw, UserPw, AxiosError>();

export const pwCheckAction = createAsyncAction(
  USERS_PWCheck_REQUEST,
  USERS_PWCheck_SUCCESS,
  USERS_PWCheck_FAILURE
)<string, boolean, AxiosError>();

const actions = {
  login,
  check,
  logout,
  refresh,
  userPageAction,
  pwUpdateAction,
  userDeleteAction,
  pwCheckAction
};

export type AuthAction = ActionType<typeof actions>;
